/**
 * Labstep
 *
 * @module core/Form/ReactForm/SelectMulti
 * @desc Input with tokenized items
 */

import { SelectMulti as CoreSelectMulti } from 'labstep-web/core/Select/Multi';
import type { MetadataOptionsValues } from 'labstep-web/models/metadata/types';
import type React from 'react';
import { Controller } from 'react-hook-form';
import type { ISelectMultiFieldProps } from './types';

export const SelectMultiField: React.FC<ISelectMultiFieldProps> = ({
  elementProps,
  control,
  name,
  onKeyPress,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field: reactHookFormField }): React.ReactElement => {
      const { value, onChange: setValue } = reactHookFormField;

      return (
        <CoreSelectMulti
          defaultValues={value as MetadataOptionsValues}
          {...elementProps}
          {...rest}
          onChange={(val: string[]) => {
            const selectedVal = val;
            if (selectedVal.length <= 0) {
              setValue(undefined as any);
            } else {
              setValue(selectedVal as any);
            }
          }}
        />
      );
    }}
  />
);
